document.addEventListener('DOMContentLoaded', function () {
  var target = new Date('2027-02-17T00:00:00');
  var daysEl = document.getElementById('cd-days');
  var hoursEl = document.getElementById('cd-hours');
  var minutesEl = document.getElementById('cd-minutes');
  var secondsEl = document.getElementById('cd-seconds');

  if (!daysEl || !hoursEl || !minutesEl || !secondsEl) {
    console.log('Countdown elements not found on page.');
    return;
  }

  function tick() {
    var diff = target - new Date();
    if (diff <= 0) {
      daysEl.textContent = '00';
      hoursEl.textContent = '00';
      minutesEl.textContent = '00';
      secondsEl.textContent = '00';
      return;
    }
    daysEl.textContent = String(Math.floor(diff / 86400000)).padStart(2, '0');
    hoursEl.textContent = String(Math.floor((diff % 86400000) / 3600000)).padStart(2, '0');
    minutesEl.textContent = String(Math.floor((diff % 3600000) / 60000)).padStart(2, '0');
    secondsEl.textContent = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
  }

  tick();
  setInterval(tick, 1000);

  console.log('Countdown script loaded and running.');
});